import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router";
import { Helmet } from "react-helmet-async";
import Container from "reactstrap/lib/Container";
import queryString from "query-string";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { sendMetriks } from "Services/sendMetriks";
import configRouters from "Configs/routes";
import { isMainSiteCode } from "Utils/siteConfig";
import SeoBlockHOC from "HOC/SeoBlockHOC";
import RandomMobileTariffListHOC from "HOC/RandomMobileTariffListHOC";
import TableComparison from "Containers/TableComparison/TableComparison";
import YandexWidgetReviews from "Containers/YandexWidgetReviews";
import OneClick from "Containers/OneClick";
import { ReviewListContainerV3 } from "Containers/Review";
import { BlockReviews } from "ComponentsUI/Blocks";
import { Banner101Rubles } from "ComponentsUI/Banner";

class House extends React.Component {
	canonical() {
		const {
			ApplicationModel: { siteConfig },
			match,
			location: { search },
		} = this.props;

		const params = queryString.parse(search);

		let location = generateUrl(configRouters.RatesInHouse.route, {
			regionUrl: match.params.regionUrl,
			house_url: match.params.house_url,
			house_id: match.params.house_id,
		});

		if (!!params.filter) {
			location += `&filter=${params.filter}`;
		}

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	render() {
		const {
			ApplicationModel: {
				siteCode,
				text,
				siteConfig,
				sendingStore,
				searcheModelOneString,
				searcheModel,
				windowSizeModel: { windowSizes },
			},
			route,
		} = this.props;
		const one_string_search = siteConfig?.settings?.one_string_search?.enabled;
		const house_id = one_string_search ? searcheModelOneString.house_id : searcheModel.house_id;

		const wasViewedHandler = (visible) => {
			sendMetriks("VIEW_TEST_SKOR");
		};

		return (
			<>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				<Banner101Rubles
					text={text}
					viewBanner={siteConfig?.settings.banner101rubles}
					bannerLocation="house"
					sendingStore={sendingStore}
				/>
				<SeoBlockHOC route={route} placeText="TableComparison">
					<TableComparison new_house_url={true} />
				</SeoBlockHOC>
				<YandexWidgetReviews contacts />
				<SeoBlockHOC route={route} placeText="YandexWidgetReviews">
					<RandomMobileTariffListHOC
						tariffsLocation="house"
						house_id={+house_id}
						textHeader={`${text.MOBILE_INTERNET_POSSIBILITY_DISTRIBUTION_ROUTER}`}
					/>
				</SeoBlockHOC>
				{!windowSizes.xs && <OneClick />}
				<Container>
					<BlockReviews
						reviewLocation="house"
						queryType="houseFull"
						text={text}
						onlyReviewsStyle={true}
						reviews={
							<ReviewListContainerV3
								text={text}
								reviewLocation="house"
								queryType="reviews"
								onlyReviewsStyle={true}
								button_send_review={true}
							/>
						}
						datatest="providers_reviews_house_unique"
					/>
				</Container>
			</>
		);
	}
}

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(House))));
